import { render } from "./TagPicker.vue?vue&type=template&id=3d087ba8&ts=true"
import script from "./TagPicker.vue?vue&type=script&lang=ts"
export * from "./TagPicker.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./TagPicker.vue?vue&type=style&index=0&id=3d087ba8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__